const paymentInfoStyle = {
    outerBox: `w-full bg-[rgba(255, 255, 255, 0.11)] outerBox`,
    borderBottom: 'border-b border-white pb-2',
    borderTop: 'border-t border-white pb-2 mb-3',
    heading: 'text-[18px] px-[10px] font-semibold text-left text-white',
    payment_methods: 'flex flex-wrap justify-center border-b border-cartBorder items-center py-4 gap-4',
    button: 'w-auto h-auto',
    border: `border-cartBorder pb-2`,
};

const checkoutFormStyles = {
    form: 'flex flex-col gap-4 pt-2',
    inputContainer: `flex flex-col gap-1`,
    label: 'text-[12px] text-[#8B8E98] ',
    inputField: `rounded-[5px] p-[13px] text-[15px] font-[300] text-[#020529] focus:outline-none focus:border-none`,
    paymentElement: `flex flex-col gap-[25px]`,

}
const timerStyles = {
    container: 'text-[18px] text-white font-semibold text-center mt-4',
};
export { paymentInfoStyle, checkoutFormStyles, timerStyles };
